import { atom } from 'jotai';

// Helper function to safely get value from localStorage
const getInitialValue = (): string | undefined => {
  try {
    if (typeof window === 'undefined') return undefined;
    const stored = localStorage.getItem('financial-application-id');
    return stored ? JSON.parse(stored) : undefined;
  } catch (error) {
    console.error('Error reading from localStorage:', error);
    return undefined;
  }
};

// Create the atom with proper initialization
export const financialApplicationIdAtom = atom<string | undefined>(
  getInitialValue()
);

// Create a derived atom that handles localStorage persistence
export const financialApplicationIdAtomWithStorage = atom(
  (get) => get(financialApplicationIdAtom),
  (_, set, newValue: string | undefined) => {
    set(financialApplicationIdAtom, newValue);
    
    // Persist to localStorage
    try {
      if (typeof window === 'undefined') return;
      if (newValue === undefined) {
        localStorage.removeItem('financial-application-id');
      } else {
        localStorage.setItem('financial-application-id', JSON.stringify(newValue));
      }
    } catch (error) {
      console.error('Error writing to localStorage:', error);
    }
  }
); 